import React from "react";
import UniversalLink from "§/src/utils/UniversalLink"
import { Link as GatsbyLink } from "gatsby";
import { sanitize } from "§/src/utils/functions";

// ASSETS
import LogoCittaDiVenezia from "§/src/images/logo/citta-di-venezia.svg";
import LogoVeneziaUnica from "§/src/images/logo/citypass-venezia-unica.svg";
import LogoEnjoyRespect from "§/src/images/logo/enjoy-respect-venezia.svg";
import LogoDime from "§/src/images/logo/dime.svg";
import LogoDimeNumber from "§/src/images/logo/dime-number.svg";
import LogoMinisteroFSC from "§/src/images/logo/ministero-turismo-fsc.svg";

import Linkedin from '§/src/images/svg/icons/Social-linkedin.svg';
import Youtube from '§/src/images/svg/icons/Social-youtube.svg';
import Instagram from '§/src/images/svg/icons/Social-instagram.svg';
import Wechat from '§/src/images/svg/icons/Social-wechat.svg';
import TikTok from '§/src/images/svg/icons/Social-tiktok.svg';
import SocialX from '§/src/images/svg/icons/Social-x.svg';
import Facebook from '§/src/images/svg/icons/Social-facebook.svg';

// MENUS
import LangMenu from '§/src/components/menus/lang-menu';
import BaseMenu from '§/src/components/menus/base-menu';
import WidgetMenu from '§/src/components/menus/widget-menu';

// Language
import { useTranslation } from 'react-i18next';

const Footer = ( { data, lang, langReplace } ) => {

	const { t } = useTranslation();
	const footerMenu1 = data.footerMenu1;
	const footerMenu2 = data.footerMenu2;
	const footerMenu3 = data.footerMenu3;
	const footerMenu4 = data.footerMenu4;
	const socialMenu = data.socialMenu;
	const langMenu = data.langMenu;
	const legalMenu = data.legalMenu;
	const locale = lang?.locale?.locale;

	const footerOptions = data.footerOptions.acfoptGlobalOptions.acfGlobal;
	const general = data.footerOptions.generalSettings;

	return (
		<footer className="footer bg-dark-red">
			<div className="container position-relative row px-0">

				<div className="waves">
					<div></div>
				</div>

				<div className="footer-left col-md-7">
					<div className="loghi">
						<LogoCittaDiVenezia className="logocittadivenezia" />
						<LogoVeneziaUnica className="logoveneziaunica" />
						<LogoEnjoyRespect className="logoenjoyrespect" />
						<div className="logodime d-inline-flex">
							<LogoDime className="dimelogo" />
							<LogoDimeNumber className="dimenumber" />
						</div>
						<a
				      href="https://cda.ve.it/" // URL da aprire
				      className="logocdave text-light fw-700" // Classe CSS
							target="_blank"
				    >
				      cda.ve.it
				    </a>
					</div>

					<div className="footer-copy col-auto order-4 order-xl-0">
						{
						footerOptions.footerCopy ?
							<p className="copy" dangerouslySetInnerHTML={ { __html: sanitize(footerOptions.footerCopy) } }></p>
						: null
						}

						{
						footerOptions.footerAzienda ?
							<p className="info mb-0" dangerouslySetInnerHTML={ { __html: sanitize(footerOptions.footerAzienda) } }></p>
						: null
						}
					</div>
				</div>

				<div className="footer-right ms-md-auto col-auto align-items-md-end">
						{
						socialMenu.nodes.length ?
							<div id="social-bottom" className="social-list d-flex flex-column flex-wrap">
								<span className="fw-700">Seguici su</span>

								<div className="icons d-flex">
									{socialMenu.nodes.map((menuItem, index) => {
										if(menuItem.cssClasses.includes('linkedin')){
											var Linkcontent = Linkedin;
										} else if(menuItem.cssClasses.includes('youtube')){
											var Linkcontent = Youtube;
										} else if(menuItem.cssClasses.includes('instagram')){
											var Linkcontent = Instagram;
										} else if(menuItem.cssClasses.includes('x')){
											var Linkcontent = SocialX;
										} else if(menuItem.cssClasses.includes('facebook')){
											var Linkcontent = Facebook;
										} else if(menuItem.cssClasses.includes('tiktok')){
											var Linkcontent = TikTok;
										} else if(menuItem.cssClasses.includes('wechat')){
											var Linkcontent = Wechat;
										} else {
											var Linkcontent = menuItem.title;
										}

										return(
											<button type="button" className="btn btn-sm btn-link" aria-label={ menuItem.title } key={index}>
												<UniversalLink
													className="text-light"
													target="_blank"
													to={ menuItem.uri }
													activeClassName="active"
												>
													<Linkcontent></Linkcontent>
												</UniversalLink>
											</button>
										)
									})}
								</div>

							</div> :
						null
						}

						<div id="menu-legal" className="base-menu w-100">
						  {locale === "it_IT" ? (
						    <React.Fragment>
						      <a target="_blank" href="https://cda.veneziaunica.it/privacy-policy">Privacy</a>
						      <a target="_self" href="/cookie-policy/">Cookie policy</a>
						    </React.Fragment>
						  ) : (
						    <React.Fragment>
						      <a target="_blank" href="https://cda.veneziaunica.it/en/privacy-policy">Privacy</a>
						      <a target="_self" href="/en/cookie-policy/">Cookie policy</a>
						    </React.Fragment>
						  )}
						</div>


				</div>
			</div>
			<div className="container row px-0">
				<div className="footer-bottom">
					<LogoMinisteroFSC className="ministlogo px-0" />
					{locale === 'it_IT' ?
					(<div className="footer-bottom-content px-0">
						<div>PIANO SVILUPPO E COESIONE DEL MINISTERO DEL TURISMO</div>
						<span>PROGETTO FINANZIATO CON RISORSE DEL FONDO PER LO SVILUPPO E LA COESIONE - DELIBERA CIPESS N.58/2021 <br></br>Area Tematica 3 “Competitività Imprese” - Settore di intervento 2 “Turismo e ospitalità” #EnjoyRespectVenezia - Grandi Destinaziono Italiane in rete</span>
					</div>) : (<div className="footer-bottom-content px-0">
						<div>MINISTRY OF TOURISM DEVELOPMENT AND COHESION PLAN</div>
						<span>PPROJECT FINANCED WITH RESOURCES FROM THE DEVELOPMENT AND COHESION FUND - CIPESS RESOLUTION NO.58/2021 <br></br>Thematic Area 3 “Business Competitiveness” - Area of Intervention 2 “Tourism and Hospitality” #EnjoyRespectVenice - Great Italian Destinations in Network</span>
					</div>)}
				</div>
			</div>
		</footer>
	);
};


export {
	Footer
};
